import React from "react";

import i18n from "../../i18n";

export default function MobileMenuButton({
                                             opened,
                                             onToggle,
                                         }) {
    return (
        <button
            className="header__mobile-button"
            type="button"
            onClick={onToggle}
            aria-controls="mobile-navigation"
            aria-expanded={opened}
        >
            {!opened ? (
                <svg
                    width="19"
                    height="13"
                    viewBox="0 0 19 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0 0H19V1H0V0ZM0 6H19V7H0V6ZM19 12H0V13H19V12Z"
                        fill="currentcolor"
                    />
                </svg>
            ) : (
                <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                        fill="currentcolor"
                    />
                </svg>
            )}

            <span>
                {i18n.t("main.header.mobileMenu")}
            </span>
        </button>
    );
}